import utilsApi from '../assets/js/utils';
export default utilsApi.creatApi({
    // 获取商城“单个”商品信息
    getShopGoods: ["post", "getShopGoods"],
    // 商品兑换接口（创建订单）
    createCurrentUserShopOrder: ["post", "//router.gamersky.com/@/shop/createOrder/6.0.0/" + utilsApi.getUserId()],
});